import React, { Component } from "react";
import { connect } from "react-redux";
import { logoutUser } from "../../actions";
import { saveStudentData } from "../../actions";
import studentData from "../Data/StudentData.json";
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ShowDaySelction from "./DaySelection.js";
import ShowGeneralInfo from "./GeneralInfo.js";
import { myFirebase } from "../../firebase/firebase";
import Paper from "@material-ui/core/Paper";
import {paper_style} from "../styles";
import Container from "@material-ui/core/Container";
import { Button } from '@material-ui/core';
import {ChildDisabilities} from "./ChildDisabilities";
import SetHeadline from "./SetHeadline.js"
import PhotoUploader from "./PhotoUploader.js"
import useStyles from "./FormStyle";
import Female from "./Female";
import Male from "./Male";
import "./gender.css"
import { Multiselect } from 'multiselect-react-dropdown';
import ActivityStatus from "./ActivityStatus.js"
import Toolbar from "../Menu/Toolbar";
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";
import cities from './StudentsCitiesNames.js';
import {green_style} from "../styles"
const checkInput = require("./CheckInput");


class StudentSignup extends Component {
    constructor() {
        super();
        this.showGeneralInfo = React.createRef();
        this.relevant_ages = React.createRef();
        this.state = {
            isLoading: true,
            allData: {},
            menuOpen: false,
            activity_status: '',
            userData: studentData,
            cities: [],
            stud_age: '',
            stud_gender: '',
            selected_ages: [],
            errors: {
                cities: '',
                stud_age: '',
                stud_gender: '',
            } 
        }
        this.handleChange = this.handleChange.bind(this);
    }

    menuClickHandler = () => {
        this.setState((prevState) => {
          return { menuOpen: !prevState.menuOpen };
        });
    };
    
    backDropClickHandler = () => {
        this.setState({ menuOpen: false });
    };

    handleLogout = () => {
        const { dispatch } = this.props;
        dispatch(logoutUser());
    };

    
    handleChange(event){
        const {name, value, type, checked} = event.target;
        type === "checkbox" ? this.setState({[name] : checked}) : this.setState({[name] : value});
    }

    handleInputChange = evt => {
        var value = evt.target.value;
        let errors = this.state.errors;
        var type = evt.target.name;
        switch (type) {
            case "stud_age":
                errors.stud_age = 
                    !checkInput.numbersCheck(value, 0,120)
                    ? 'גיל אינו תקין'
                    : '';
                break;
            case "stud_gender":
                this.setState({chosenGender : true});
                errors.stud_gender =
                    value != ""
                    ? ''
                    :'נא בחר מגדר';
            break;
        }    
        this.setState({errors, [type]: value}, ()=> {
            console.log(errors)
        })
    }

    handleSaveData = () => {
        const { dispatch } = this.props;
        if(!this.checkAllData()) {
            window.alert("ישנם שדות שאינם תקינים");
        } else {
            var student_data;
            if(this.props.currUser != undefined) {
                student_data = loadStudentData(this.state.userData.stud_picture, this.relevant_ages.current.getSelectedItems(), false, this.state.cities);
            } else {
                student_data = loadStudentData(this.state.userData.stud_picture, this.relevant_ages.current.getSelectedItems(), true, this.state.cities);
            }
            dispatch(saveStudentData(student_data));
            if(this.props.currUser != undefined) {
                this.props.history.push('/');
            } else {
                this.props.history.push('/confirm');
            }
        }
    };


    handleChange(event){
        const {name, value, type, checked} = event.target;
        type === "checkbox" ? this.setState({[name] : checked}) : this.setState({[name] : value});
    }

    checkAllData = () => {
        var genValid = this.showGeneralInfo.current.checkAllIputValidation();
        let errors = this.state.errors;
        if(this.state.errors.stud_gender == '') {
            if(!this.state.chosenGender) {
                errors.stud_gender = 'נא בחר מגדר';
            }
            errors.stud_gender = '';
        }
        errors.stud_age = 
            !checkInput.numbersCheck(this.state.stud_age,0,120)
            ? 'גיל הילד אינו תקין'
            : '';
        errors.cities = 
            this.state.cities.length == 0
            ? 'בחר עיר אחת לפחות'
            : '';
        this.setState({errors}, ()=> {
            console.log(errors)
        })
        if(checkInput.validateForm(this.state.errors) && this.state.chosenGender && genValid) {
            return true;
          } else {
            return false;
          }
    }
    
    async componentWillMount()  {
        console.log(this.props.currUser);
        if(this.props.currUser != undefined) {
            this.setState({userData:this.props.currUser})
            this.setState({activity_status : <ActivityStatus userStatus={this.props.currUser.activity_status}/>})
            this.setState({stud_age :this.props.currUser.age})
            this.setState({stud_gender :this.props.currUser.stud_gender})
            this.setState({chosenGender :true})
            this.setState({cities:this.props.currUser.cities})
            let ages = this.props.currUser.relevant_ages;
            if(ages.no_preference) {
                this.state.selected_ages.push({name:"אין העדפה", id:"no_preference"})
            }
            if(ages.zero_to_one) {
                this.state.selected_ages.push({name:"0-1", id:"zero_to_one"})
            }
            if(ages.one_to_two) {
                this.state.selected_ages.push({name:"1-2", id:"one_to_two"})
            }
            if(ages.two_to_five) {
                this.state.selected_ages.push({name:"2-5", id:"two_to_five"})
            }
            if(ages.five_to_twelve) {
                this.state.selected_ages.push({name:"5-12", id:"five_to_twelve"})
            }
            if(ages.twelve_to_twenty_five) {
                this.state.selected_ages.push({name:"12-25", id:"twelve_to_twenty_five"})
            }
            if(ages.twenty_five_plus) {
                this.state.selected_ages.push({name:"25+", id:"twenty_five_plus"})
            }       
         }
    }

    setRelevantAges = (ages) => {
        if(ages.no_preference) {
            this.state.selected_ages.push({name:"אין העדפה", id:"no_preference"})
        }
        if(ages.zero_to_one) {
            this.state.selected_ages.push({name:"0-1", id:"zero_to_one"})
        }
        if(ages.one_to_two) {
            this.state.selected_ages.push({name:"1-2", id:"one_to_two"})
        }
        if(ages.two_to_five) {
            this.state.selected_ages.push({name:"2-5", id:"two_to_five"})
        }
        if(ages.five_to_twelve) {
            this.state.selected_ages.push({name:"5-12", id:"five_to_twelve"})
        }
        if(ages.twelve_to_twenty_five) {
            this.state.selected_ages.push({name:"12-25", id:"twelve_to_twenty_five"})
        }
        if(ages.twenty_five_plus) {
            this.state.selected_ages.push({name:"25+", id:"twenty_five_plus"})
        }
    }

    callbackFunction = (photo_name) => {
        this.state.userData.stud_picture = photo_name;
    }

    onCitySelect = (selectedList, selectedItem) => {
        this.state.cities = selectedList;
        let errors = this.state.errors;
        errors.cities = '';
        this.setState({errors}, ()=> {
            console.log(errors)
        })
    }
     
    onCityRemove = (selectedList, removedItem) => {
        this.state.cities = selectedList
        console.log(this.state.cities)
    }
    
    setRegisterButtonLable = () => {
        let lable;
        if(this.props.currUser != undefined) {
            lable = "עדכון פרסום"
        } else {
            lable = "הרשמה"
        }
        return(
        <Button variant="contained" style={green_style} size="large" disableElevation onClick={this.handleSaveData}>
            {lable}   
        </Button>
        );
    }
   
    render() {
        let headline;
        var sideDrawer;
        var backDrop;
        // for an existing user display "my account" toolbar with menu button.
        if (this.props.currUser != undefined) {
            headline = <Toolbar drawerClickHandler={this.menuClickHandler} textPage="החשבון שלי"/> 
            if (this.state.menuOpen) {
                sideDrawer = <SideDrawer closeMenu={this.backDropClickHandler} />;
                backDrop = <BackDrop click={this.backDropClickHandler} />;
            }
        // for new user display "signup" toolbar with no menu button.
        } else {
            headline = <SetHeadline type="כבייביסיטר מיוחד"/>
            sideDrawer = <div></div>
            backDrop = <div></div>
        }
        const iconStyle = { position: 'absolute', left: 0, top: 0, pointerEvents : 'none'};
        const newIcon = (props) => {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" style={iconStyle} width="32" height="32" viewBox="0 0 45 45">
                    <path fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="2" d="M17 20l5.467 5.467L27.934 20"/>
                </svg>
            )
        };
        const errStyle = {
            color: 'red',
            fontSize: '12px',
            textAlign: 'right',
            fontWeight: 'bold',
          };
          const options = [
            { name: 'אין העדפה', id: "no_preference"},
            { name: '0-1' ,id:"zero_to_one"},
            { name: '1-2' ,id:"one_to_two"},
            { name: '2-5' ,id:"two_to_five"},
            { name: '5-12' ,id:"five_to_twelve"},
            { name: '12-25',id:"twelve_to_twenty_five"},
            { name: '25+' ,id:"twenty_five_plus"}
          ];
        const { isLoggingOut, logoutError } = this.props;
        const {errors} = this.state;
        const {classes} = this.props;
        let photoDisplay;
        return (
            <React.Fragment>
                {headline}
                {sideDrawer}
                {backDrop}
                <Container component="main" maxWidth="xs">
                    <div dir="rtl" align="center" >
                        <br/>
                        <br/>
                        <br/>
                        <PhotoUploader photo_name={this.state.userData.stud_picture} parentCallback = {this.callbackFunction} />
                        {this.state.activity_status}
                        <ShowGeneralInfo ref={this.showGeneralInfo}
                                         user={this.state.userData}
                                         full_name_label="* שם מלא"
                        />

                        <div className={classes.input_text}>
                            * בחר/י ערים בהם תרצה לעבוד  
                        </div>
                        <Multiselect fullWidth align="right" id="relevant_cities"
                            defaultValue="אין העדפה"
                            ref={this.relevant_cities}
                            autoFocus={false}
                            isRtl={true}
                            options={cities} // Options to display in the dropdown
                            onSelect={this.onCitySelect} // Function will trigger on select event
                            onRemove={this.onCityRemove}
                            showCheckbox={true}
                            placeholder=""
                            selectedValues={this.state.cities} // Preselected value to persist in dropdown
                            displayValue="name" // Property name to display in the dropdown options
                        />
                        <p>{errors.cities.length > 0 && <span style={errStyle} className='error'>{errors.cities}</span>}</p>
                        <div className={classes.input_text}>
                            * מגדר  
                        </div>
                        <label>
                            <input type="radio"
                                   name="stud_gender"
                                   value="female"
                                   checked={this.state.stud_gender === "female"}
                                   onChange={this.handleInputChange}
                            />
                            <Female/>
                        </label>
                        

                        <label>
                            <input type="radio"
                                   name="stud_gender"
                                   value="male"
                                   checked={this.state.stud_gender === "male"}
                                   onChange={this.handleInputChange}

                            />
                            <Male/>
                        </label>
                        <br/>
                        <div className={classes.input_text}>
                            * גיל 
                        </div>
                        <TextField name="stud_age"
                                   onChange={this.handleInputChange}
                                   defaultValue={this.state.userData.age}
                                    type="text"
                                   fullWidth
                        />
                        <p>{errors.stud_age.length > 0 && <span style={errStyle} className='error'>{errors.stud_age}</span>}</p>

                        <br/>

                        <p className={classes.input_text}>אני פנוי/ה לבייביסיטר בזמנים : </p>
                            <ShowDaySelction user={this.state.userData} day="sunday"/>
                            <ShowDaySelction user={this.state.userData} day="monday"/>
                            <ShowDaySelction user={this.state.userData} day="tuesday"/>
                            <ShowDaySelction user={this.state.userData} day="wednesday"/>
                            <ShowDaySelction user={this.state.userData} day="thursday"/>
                            <ShowDaySelction user={this.state.userData} day="friday"/>
                            <ShowDaySelction user={this.state.userData} day="saturday"/>
                        <br/>

                        <div className={classes.input_text} style={{fontFamily:"Open Sans Hebrew"}}>
                         אני מעדיפ/ה לעשות בייביסיטר לילדים בגילאי   
                        </div>
                      
                        <Multiselect fullWidth align="right" id="relevant_ages"
                            defaultValue="אין העדפה"
                            ref={this.relevant_ages}
                            autoFocus={false}
                            isRtl={true}
                            options={options} // Options to display in the dropdown
                            showCheckbox={true}
                            placeholder=""
                            selectedValues={this.state.selected_ages} // Preselected value to persist in dropdown
                            displayValue="name" // Property name to display in the dropdown options
                        />
                        <br/>
                        <FormControl variant="outlined" fullWidth>
                            <div className={classes.input_text} style={{fontFamily:"Open Sans Hebrew"}}>
                                עיסוק נוכחי                        
                            </div>
                            <Select className={classes.input_text} name="current_occupation" defaultValue={this.state.userData.current_occupation} native labelWidth="100">
                                <option value="student">סטודנט/ית</option>
                                <option value="service_duty">בן/בת שירות</option>
                                <option value="assistance">סייע/ת</option>
                                <option value="care_staff_member">איש/אשת צוות טיפולי</option>
                                <option value="teacher">מורה/גננת בחינוך מיוחד</option>
                                <option value="other">אחר</option>
                            </Select>
                        </FormControl>
                        <br/>
                        <br/>
                        
                        <div align="right">
                            <p className={classes.input_text}>אני מעדיפ/ה לעשות בייביסיטר לילדים : </p>
                            <ChildDisabilities user={this.state.userData} type="student"/>
                        </div>
                        <p className={classes.input_text}>*להמשך בירור פרטים והתקשרות יש ליצור קשר עם מקבל השירות</p>
                        {this.setRegisterButtonLable()}
                    </div>
                </Container>
            </React.Fragment>

        );
    }
}



function mapStateToProps(state) {
    return {
        isLoggingOut: state.auth.isLoggingOut,
        logoutError: state.auth.logoutError,
        currUser: state.currentUser,
    };
}

function loadStudentData(photoe_name, relevant_ages, is_new_account, cities_to_work_in) {
    const student_data = studentData;
    if(is_new_account) {
        var date = new Date(); 
        var month =  date.getMonth() + 1;
        var full_date = date.getDate() + "." + month + "." + date.getFullYear();
        student_data.registration_date =  full_date;
        console.log( full_date);
        student_data.activity_status = true;
    } else {
        student_data.activity_status = document.getElementsByName("activity_status")[0].checked;
    }    student_data.full_name =  document.getElementsByName("full_name")[0].value;
    student_data.email = (myFirebase.auth().currentUser.email).toLowerCase();
    student_data.cities = cities_to_work_in;
    student_data.phone_number = document.getElementsByName("phone_number")[0].value;
    student_data.region = document.getElementsByName("region")[0].value;
   // student_data.city = document.getElementsByName("city")[0].value;
    student_data.age = document.getElementsByName("stud_age")[0].value;
    student_data.stud_picture = photoe_name;
    student_data.relevant_ages.no_preference = false;
    student_data.relevant_ages.zero_to_one = false;
    student_data.relevant_ages.one_to_two = false;
    student_data.relevant_ages.two_to_five = false;
    student_data.relevant_ages.five_to_twelve = false;
    student_data.relevant_ages.twelve_to_twenty_five = false;
    student_data.relevant_ages.twenty_five_plus = false;
    console.log(relevant_ages)
    relevant_ages.forEach(age => {switch(age.name) {
        case 'אין העדפה':
            student_data.relevant_ages.no_preference = true;
            break;
        case '0-1':
            student_data.relevant_ages.zero_to_one = true;
            break;
        case '1-2':
            student_data.relevant_ages.one_to_two = true;
            break;
        case '2-5':
            student_data.relevant_ages.two_to_five = true;
            break;
        case '5-12':
            student_data.relevant_ages.five_to_twelve = true;
            break;
        case '12-25':
            student_data.relevant_ages.twelve_to_twenty_five = true
            break;
        case '25+':
            student_data.relevant_ages.twenty_five_plus = true
            break;
        default:
      }})
    if(document.getElementsByName("stud_gender")[0].checked) {
        student_data.stud_gender = "female"
    } else {
        student_data.stud_gender = "male"
    }
    student_data.is_no_preference = document.getElementsByName("is_no_preference")[0].checked;
    student_data.is_autistic_spectrum = document.getElementsByName("is_autistic_spectrum")[0].checked;
    student_data.is_intellectual_limitation = document.getElementsByName("is_intellectual_limitation")[0].checked;
    student_data.is_delayed_developed = document.getElementsByName("is_delayed_developed")[0].checked;
    student_data.is_physical_limitation = document.getElementsByName("is_physical_limitation")[0].checked;
    student_data.is_behavioral_difficulty = document.getElementsByName("is_behavioral_difficulty")[0].checked;
    student_data.is_nursing_assistance = document.getElementsByName("is_nursing_assistance")[0].checked;
    student_data.is_medical_assistance = document.getElementsByName("is_medical_assistance")[0].checked;
    student_data.is_other = document.getElementsByName("is_other")[0].checked;
    student_data.current_occupation = document.getElementsByName("current_occupation")[0].value;
    student_data.work_on_sunday.is_needed = document.getElementsByName("sunday")[0].checked;
    if(student_data.work_on_sunday.is_needed) {
        student_data.work_on_sunday.start_time = document.getElementsByName("sunday_start")[0].value;
        student_data.work_on_sunday.end_time = document.getElementsByName("sunday_end")[0].value;
    }

    student_data.work_on_monday.is_needed = document.getElementsByName("monday")[0].checked;
    if(student_data.work_on_monday.is_needed) {
        student_data.work_on_monday.start_time = document.getElementsByName("monday_start")[0].value;
        student_data.work_on_monday.end_time = document.getElementsByName("monday_end")[0].value;
    }

    student_data.work_on_tuesday.is_needed = document.getElementsByName("tuesday")[0].checked;
    if(student_data.work_on_tuesday.is_needed) {
        student_data.work_on_tuesday.start_time = document.getElementsByName("tuesday_start")[0].value;
        student_data.work_on_tuesday.end_time = document.getElementsByName("tuesday_end")[0].value;
    }

    student_data.work_on_wednesday.is_needed = document.getElementsByName("wednesday")[0].checked;
    if(student_data.work_on_wednesday.is_needed) {
        student_data.work_on_wednesday.start_time = document.getElementsByName("wednesday_start")[0].value;
        student_data.work_on_wednesday.end_time = document.getElementsByName("wednesday_end")[0].value;
    }

    student_data.work_on_thursday.is_needed = document.getElementsByName("thursday")[0].checked;
    if(student_data.work_on_thursday.is_needed) {
        student_data.work_on_thursday.start_time = document.getElementsByName("thursday_start")[0].value;
        student_data.work_on_thursday.end_time = document.getElementsByName("thursday_end")[0].value;
    }

    student_data.work_on_friday.is_needed = document.getElementsByName("friday")[0].checked;
    if(student_data.work_on_friday.is_needed) {
        student_data.work_on_friday.start_time = document.getElementsByName("friday_start")[0].value;
        student_data.work_on_friday.end_time = document.getElementsByName("friday_end")[0].value;
    }

    student_data.work_on_saturday.is_needed = document.getElementsByName("saturday")[0].checked;
    if(student_data.work_on_saturday.is_needed) {
        student_data.work_on_saturday.start_time = document.getElementsByName("saturday_start")[0].value;
        student_data.work_on_saturday.end_time = document.getElementsByName("saturday_end")[0].value;
    }
    console.log(student_data)
    return student_data;
}



export default withStyles(useStyles)(connect(mapStateToProps)(StudentSignup));

